import { render, staticRenderFns } from "./ModalForceRead.vue?vue&type=template&id=5a779332&scoped=true"
import script from "./ModalForceRead.vue?vue&type=script&lang=js"
export * from "./ModalForceRead.vue?vue&type=script&lang=js"
import style0 from "./ModalForceRead.vue?vue&type=style&index=0&id=5a779332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a779332",
  null
  
)

export default component.exports